import { ReactElement } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { get } from 'lodash-es';

import { ErrorLayout, ErrorLayoutProps } from '../components/ErrorLayout';
import { translate } from '../utils/translations';

/**
 * エラーページ
 *
 * @returns JSX.Element
 */
export function Error(): ReactElement {
  const navigate = useNavigate();
  const error = useRouteError();
  const traceparentId = get(error, 'config.headers.Traceparent', undefined);
  const errorTitle = get(error, 'title', translate('ERROR_MESSAGE.001'));
  const errorMessage = get(error, 'message', translate('ERROR_MESSAGE.002'));
  // const errorCode = get(error, 'response.errorCode', undefined);
  // const errorStatusCode = get(error, 'response.status', undefined);

  const button: ErrorLayoutProps['button'] = {
    text: translate('COMMON.BACK'),
    onClick: () => {
      const backPath = location.pathname;
      navigate(backPath);
    },
  };

  return (
    <ErrorLayout
      title={errorTitle}
      message={errorMessage}
      button={button}
      traceparentId={traceparentId}
    />
  );
}
